import {useMutation} from '@tanstack/react-query'
import {useGetOrderApiMethod} from 'api/useGetOrderApiMethod'
import {usePatchBookingApiMethod} from 'api/usePatchBookingApiMethod'
import {Ventrata} from 'types'

type BookingUnitItems = {
  bookingUuid: string
  unitItems: Ventrata.RequestUnitItem[]
}

type Params = {
  orderId: string
  bookingsUnitItems: BookingUnitItems[]
}

export const useSetQuestionAnswersMutation = () => {
  const getOrder = useGetOrderApiMethod()
  const patchBooking = usePatchBookingApiMethod()

  return useMutation({
    mutationFn: async ({bookingsUnitItems, orderId}: Params) => {
      for (const bookingUnitItems of bookingsUnitItems) {
        await patchBooking({
          bookingUuid: bookingUnitItems.bookingUuid,
          unitItems: bookingUnitItems.unitItems,
        })
      }

      return await getOrder(orderId)
    },
  })
}
